import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var FilterFunnel01 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "filter-funnel01",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 4.6c0-.56 0-.84.109-1.054a1.0001 1.0001 0 0 1 .437-.437C2.76 3 3.04 3 3.6 3h16.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C22 3.76 22 4.04 22 4.6v.6694c0 .2688 0 .4032-.0328.5282a1.0029 1.0029 0 0 1-.1417.3102c-.0729.1066-.1745.1947-.3776.3707l-6.3958 5.543c-.2031.176-.3047.2641-.3776.3707a1.0042 1.0042 0 0 0-.1417.3102c-.0328.125-.0328.2594-.0328.5282v5.2278c0 .1955 0 .2933-.0315.3779a.5.5 0 0 1-.1322.1952c-.0668.0607-.1576.097-.3392.1697l-3.4 1.36c-.3675.147-.5513.2205-.6988.1898a.4997.4997 0 0 1-.315-.2133C9.5 20.4122 9.5 20.2142 9.5 19.8184v-6.5878c0-.2688 0-.4032-.0328-.5282a1.001 1.001 0 0 0-.1417-.3102c-.073-.1066-.1745-.1947-.3776-.3707L2.552 6.4785c-.2031-.176-.3047-.264-.3776-.3707a.9998.9998 0 0 1-.1417-.3102C2 5.6726 2 5.5382 2 5.2694V4.6Z"
    })
  }));
};
export default FilterFunnel01;